import React from 'react';
import SidePanel from './SidePanel';
import {last} from 'lodash';

const SidePanelContext = React.createContext({
  isSidePanelOpen: false,
  sidePanelContent: []
});

export class SidePanelProvider extends React.Component {
  state = {
    isSidePanelOpen: false,
    showBackdrop: false,
    sidePanelContent: []
  };
  timeout = [];

  pushSidePanel = ({title, content, onClose}) => {
    if (this.state.isSidePanelOpen) {
      this.setState({isSidePanelOpen: false, showBackdrop: true});
      this.waitForAnimation(() => this.addSidePanelToArray({title, content, onClose}));
      return;
    }

    this.addSidePanelToArray({title, content, onClose});
  };

  addSidePanelToArray = ({title, content}) => {
    this.setState(prevState => ({
      isSidePanelOpen: true,
      showBackdrop: true,
      sidePanelContent: [...prevState.sidePanelContent, {title, content}]
    }));
  };

  popSidePanel = () => {
    if (!this.state.isSidePanelOpen || this.state.sidePanelContent.length === 0) return;

    const lastPanel = last(this.state.sidePanelContent);
    if (typeof lastPanel?.onClose === 'function') {
      const result = lastPanel.onClose();
      if (result === false) return;
    }

    const nextSidePanelContent = this.state.sidePanelContent.slice(0, -1);

    if (nextSidePanelContent.length) {
      this.setState({isSidePanelOpen: false});
      this.waitForAnimation(() =>
        this.setState(prevState => ({
          isSidePanelOpen: true,
          showBackdrop: true,
          sidePanelContent: prevState.sidePanelContent.slice(0, -1)
        }))
      );

      return;
    }

    this.setState({isSidePanelOpen: false, showBackdrop: false}, () => {
      this.waitForAnimation(() =>
        this.setState({
          sidePanelContent: []
        })
      );
    });
  };

  setLastPanelOptions = options => {
    const lastPanel = last(this.state.sidePanelContent);
    if (!lastPanel) return;
    const newLastPanel = {...lastPanel, ...options};
    this.setState(prevState => ({
      sidePanelContent: [...prevState.sidePanelContent.slice(0, -1), newLastPanel]
    }));
  };

  waitForAnimation = callback => {
    this.timeout.push(setTimeout(callback, 300));
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    this.timeout.forEach(clearTimeout);
  }

  handleKeyDown = e => {
    // Close with ESC key
    if (e.keyCode === 27) {
      this.popSidePanel();
    }
  };

  render() {
    return (
      <SidePanelContext.Provider
        value={{
          isSidePanelOpen: this.state.isSidePanelOpen,
          sidePanelContent: this.state.sidePanelContent,
          pushSidePanel: this.pushSidePanel,
          popSidePanel: this.popSidePanel,
          setLastPanelOptions: this.setLastPanelOptions
        }}
      >
        {this.props.children}
        <SidePanel
          showBackdrop={this.state.showBackdrop}
          isSidePanelOpen={this.state.isSidePanelOpen}
          popSidePanel={this.popSidePanel}
          title={last(this.state.sidePanelContent)?.title}
        >
          {last(this.state.sidePanelContent)?.content}
        </SidePanel>
      </SidePanelContext.Provider>
    );
  }
}

export const withSidePanel = Component => {
  return class extends React.Component {
    render() {
      return (
        <SidePanelContext.Consumer>
          {sidePanelContextValue => <Component {...this.props} {...sidePanelContextValue} />}
        </SidePanelContext.Consumer>
      );
    }
  };
};
